import { render, staticRenderFns } from "./NotificationsWidget.vue?vue&type=template&id=03b8eeca&"
import script from "./NotificationsWidget.js?vue&type=script&lang=js&"
export * from "./NotificationsWidget.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports